module.exports = ":root{--lui-icon-color:var(--lui-text-color)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-icon/theme/lui-icon.global.scss
// module id = 217
// module chunks = 0 1 12